import axios from "axios";
import store from '@/store/index';

// const domain = process.env.VUE_APP_AUTH_REPOSITORY_URL;

export default {

  getBaseUrl() {
    const authType = store.getters.getAuthType;
    if (authType === 'token') {
      return process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/';
    }
    return process.env.VUE_APP_AUTH_REPOSITORY_URL;
  },

  createRequest(includeAuthHeader = true) {
    let instance = axios.create({ baseURL: this.getBaseUrl() });
    if (includeAuthHeader) {
      instance.interceptors.request.use(
        (config) => {
          let token = localStorage['auth__access_token'];
          //let token = window.$cookies.get('auth__access_token');
          if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
          }
          return config;
        }
      );
    }
    return instance;
  },

  checkLogin() {
    return this.createRequest().get('/');
  },

  signUp(data) {
    return this.createRequest().post('sign-up', data);
  },

  signUpGuest(username, email, password) {
    return this.createRequest().post('sign-up/guest', { username, email, password });
  },

  resendConfirmation(username) {
    return this.createRequest().post('resend-confirmation', { username });
  },

  confirmSignUp(username, code) {
    return this.createRequest().post('confirm-sign-up', { username, code });
  },

  invite(username, email, password) {
    return this.createRequest().post('invite', { username, email, password });
  },

  login(username, password) {
    return this.createRequest().post('login', { username, password });
  },

  loginWithResultsToken(initialToken) {
    return this.createRequest(false).post('token-auth', { token: initialToken });
  },

  logout(username) {
    return this.createRequest().post('logout', { username });
  },

  change(username, password, session) {
    return this.createRequest().post('change', { username, password, session });
  },

  refresh(token) {
    const authType = store.getters.getAuthType;
    const endpoint = authType === 'token' ? 'token-auth/refresh' : 'refresh';
    return this.createRequest().post(endpoint, { token });
  },

  passwordReset(email) {
    return this.createRequest().post("reset-password", { email });
  },

  passwordResetConfirm(email, code, password) {
    return this.createRequest().post("reset-password-confirm", { email, code, password });
  },

  updateEmailRequest(email) {
    return this.createRequest().post("update-email", { email })
  },

  confirmEmailChange(email, code) {
    return this.createRequest().post("update-email-confirm", { email, code });
  }

};
